import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Palette, Settings2, Trash2 } from 'lucide-react';

export function RolesDialog({
  open,
  onClose,
  jobRoles,
  roleFormData,
  setRoleFormData,
  editingRole,
  setEditingRole,
  onSave,
  onDelete,
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Palette size={18} />
            Manage Job Roles
          </DialogTitle>
          <DialogDescription>
            Create roles with custom colors to organize your schedule.
          </DialogDescription>
        </DialogHeader>

        {/* Role form */}
        <div className="space-y-3 p-3 bg-slate-50 rounded-lg">
          <div className="grid grid-cols-3 gap-2">
            <div className="col-span-2 space-y-1">
              <Label className="text-xs">Role Name</Label>
              <Input
                placeholder="e.g. Manager, Cashier"
                value={roleFormData.name}
                onChange={(e) => setRoleFormData(p => ({ ...p, name: e.target.value }))}
              />
            </div>
            <div className="space-y-1">
              <Label className="text-xs">Color</Label>
              <div className="flex items-center gap-2">
                <Input
                  type="color"
                  value={roleFormData.color}
                  onChange={(e) => setRoleFormData(p => ({ ...p, color: e.target.value }))}
                  className="w-12 h-9 p-1 cursor-pointer"
                />
                <span className="text-xs text-slate-500 uppercase">{roleFormData.color}</span>
              </div>
            </div>
          </div>
          <div className="space-y-1">
            <Label className="text-xs">Description (optional)</Label>
            <Input
              placeholder="Brief description"
              value={roleFormData.description}
              onChange={(e) => setRoleFormData(p => ({ ...p, description: e.target.value }))}
            />
          </div>
          <Button size="sm" onClick={onSave} className="w-full">
            {editingRole ? 'Update Role' : 'Add Role'}
          </Button>
        </div>

        {/* Existing roles */}
        <div className="flex-1 overflow-y-auto mt-3 space-y-2">
          {jobRoles.length === 0 ? (
            <p className="text-sm text-slate-500 text-center py-4">No roles created yet</p>
          ) : (
            jobRoles.map((role) => (
              <div
                key={role.id}
                className="flex items-center justify-between p-2 border border-slate-200 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <span
                    className="w-4 h-4 rounded-full flex-shrink-0"
                    style={{ backgroundColor: role.color }}
                  />
                  <div>
                    <p className="text-sm font-medium text-slate-900">{role.name}</p>
                    {role.description && (
                      <p className="text-xs text-slate-500">{role.description}</p>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-1">
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-7 w-7"
                    onClick={() => {
                      setEditingRole(role);
                      setRoleFormData({ name: role.name, description: role.description || '', color: role.color });
                    }}
                  >
                    <Settings2 size={14} />
                  </Button>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="h-7 w-7 text-red-500 hover:text-red-600"
                    onClick={() => onDelete(role.id)}
                  >
                    <Trash2 size={14} />
                  </Button>
                </div>
              </div>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
